import { getQueryString } from '../../domain/url-provider';
import ReactDOM from 'react-dom';
import React from 'react';
import AddToCartPopup from './ui/add-to-cart-popup';
import { Provider } from 'react-redux';
import store from './data/store';

/**
 * Parse href and get parameters from it.
 */
const getHrefParams = (href: string) => {
    if (!href) return null;

    href = href.toLowerCase().trim();
    const qs = getQueryString(href.substring(href.indexOf('?')));
    if (!qs) return null;

    const productId = Number(qs.productid);
    if (isNaN(productId)) return null;

    return {
        productId,
        coupon: qs.coupon || '',
    };
};

/**
 * Handle <div data-cart="open" ...><a href="/cart?productid=622">ADD TO CART</a></div> onClick event.
 */
const handleAddToCartDivClick = (evt: MouseEvent, $div: HTMLElement, href: string) => {
    if(!$div) return;

    const dataCart = $div.getAttribute('data-cart') || '';
    if (dataCart !== 'open') return;

    /*// https://wavesaudio.atlassian.net/browse/DSWEB-4350
    const abtest = getABTest('AddToCartAATest');
    if(abtest?.isActive) {
        sendABTestAnalytics(abtest);
    }*/

    // get props from URL
    const params = getHrefParams(href);
    if(!params) return;

    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();

    const { productId } = params;

    const id = 'add-to-cart-popup-root';
    let $popupRoot = document.getElementById(id);

    if ($popupRoot) {
        try{
            ReactDOM.unmountComponentAtNode($popupRoot);
        }
        catch (ex) { }

        $popupRoot.parentNode?.removeChild($popupRoot);
    }

    // append popup root only once (if it doesn't exist)
    $popupRoot = document.createElement('div');
    $popupRoot.id = id;
    document.body.appendChild($popupRoot);

    ReactDOM.render(
        <Provider store={ store }>
            <AddToCartPopup productId={ productId } />
        </Provider>,
        $popupRoot
    );
};

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-3692
 * https://wavesaudio.atlassian.net/browse/DSWEB-158
 */
export const initAddToCartPopup = () => {

    /**
     * Recognize the structure <div data-cart="open" ...><a href="/cart?productid=622">ADD TO CART</a></div>
     * and handle DIV on click event.
     */
    document.addEventListener('click', (evt) => {
        const $el = evt.target as HTMLElement;
        const nodeName = $el.nodeName
            ? (evt.target as HTMLElement).nodeName.toLowerCase().trim()
            : '';

        // when clicked on <a> with parent <div data-cart=...
        if (
            nodeName === 'a' &&
            $el.parentNode &&
            ($el.parentNode as HTMLElement).hasAttribute('data-cart')
        ) {
            const href = $el.getAttribute('href');

            if (href) {
                handleAddToCartDivClick(evt, $el.parentNode as HTMLElement, href);
                return;
            }
        }

        // when click on <div data-cart=...
        if (nodeName === 'div' && $el.hasAttribute('data-cart')) {
            const $a = $el.querySelector('a');

            if ($a) {
                handleAddToCartDivClick(evt, $el, $a.getAttribute('href') || '');
                return;
            }
        }

        // when clicked on element inside <a>, for example <div data-cart=...><a ...><span....
        const $closest = $el.closest('[data-cart="open"]');
        if ($closest && $closest.childNodes && $closest.childNodes.length > 0) {
            const $a = Array.from($closest.childNodes).find(
                ($node) => $node.nodeName.toLowerCase().trim() === 'a'
            );

            if ($a) {
                handleAddToCartDivClick(evt, $closest as HTMLElement, ($a as HTMLElement).getAttribute('href') || '');
                // return;
            }
        }
    });
};